import styled, { css } from 'styled-components'

interface PropsFormControl {
  tabFocus: boolean;
  focus: boolean;
  error: boolean;
  disabled: boolean;
}

export const FormControl = styled.div<PropsFormControl>`
  display: flex;
  flex-direction: column;
  width:95%;
  padding: 0px 20px 20px 20px;
  .tabFocus {
    display: flex;
    flex-direction: column;
  }
  ${(props) =>
      props.tabFocus &&
      css`
      .tabFocus {
        ${(props) => props.theme.states.focus};
      }
    `}
  ${(props) =>
      props.focus &&
      css`
      label {
        ${(props) => props.theme.states.actived.label};
      }
      .input-wrapper {
        ${(props) => props.theme.states.actived.inputWrapper};
      }
    `}
  ${(props) =>
      !props.disabled &&
      css`
      &:hover {
        .input-wrapper {
          ${(props) => props.theme.states.hover.inputWrapper}
        }
      }
    `}
  ${(props) =>
      props.error &&
      css`
      label {
        ${(props) => props.theme.states.error.label}
      }
      .input-wrapper {
        ${(props) => props.theme.states.error.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.error.helper}
      }
    `}
  ${(props) =>
      props.disabled &&
      css`
      label {
        ${(props) => props.theme.states.disabled.label}
      }
      .input-wrapper {
        ${(props) => props.theme.states.disabled.inputWrapper}
      }
      span {
        ${(props) => props.theme.states.disabled.helper}
      }
    `}'
`;

interface PropsLabel {
  htmlFor: string;
}

export const Label = styled.label<PropsLabel>`
  ${(props) => props.theme.label};
  ${(props) => props.theme.motion}
`;

export const InputAttachmentWrapper = styled.div`
  display: flex;
  box-sizing: border-box;

  flex: 1;
  color: #bdbdbd;
  display: flex;
  outline: none;
  transition: border .24s ease-in-out;
  align-items: center;
  border-color: #C6C8CC;
  border-style: dashed;
  border-width: 1px;
  border-radius: 8px;
  flex-direction: column;


  ${(props) => props.theme.inputAttachmentWrapper};
  ${(props) => props.theme.motion}
 
`;


export const DropFiles = styled.div`
flex: 1;
width: 100%;
display: flex;
align-items: center;
flex-direction: column;
 
`;

export const DropZoneArea = styled.div`
  width: 100%;
  padding: 1% 0% 1% 2%;
`;

export const DropZoneAreaItem = styled.div`
  color: #000;
  width: 96%;
  margin: 1.5%;
  font-size: 0.9em;
  font-weight: bolder;
  line-height: 2em;
  border-radius: 8px;
  background-color: #F4F5F7;
  padding: 1% 1% 2% 1%;
`;



export const SearchFile = styled.button`
 width: 124px;
 height: 40px;
 border-radius: 8px;
 border: 1px dashed #666666;
 cursor: pointer;

 label {
  position: relative;
  text-decoration: none;
  cursor: pointer;
  color: rgb(44, 110, 242);
  font-size: 16px;
  font-weight: 500;
  font-family: Inter;
  line-height: 100%;
  padding-bottom: 4px;
  transition-timing-function: cubic-bezier(0.48, 0, 0.48, 1);
  text-decoration: underline;
  text-decoration-color: rgb(44, 110, 242); 
  text-decoration-thickness: 1px;
  text-decoration-skip-ink: none; 
  padding-bottom: 5px; 
 }


`;

export const SearchFileText = styled.span`

font-family: Inter;
 font-size: 16px;
 font-weight: 400;
 line-height: 24px;
 letter-spacing: 0em;
 text-align: left;
 color: #000000;

`;










 

interface PropsHelper {
  disabled: boolean;
}

export const Helper = styled.span<PropsHelper>`
  display: flex;
  ${(props) => props.theme.helper};
  .icon {
    ${(props) => props.theme.helper.icon};
  }

  .error{
    color: red;
  }
`;

 

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`